//	Own-want button set
import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import classNames from 'classnames'
import Icon from './Icon'
import BuyButton from './BuyButton'
import styles from './OwnWant.icss'
import shortNumber from '../utilities/shortNumber'

class OwnWant extends React.Component {
	static getDerivedStateFromProps(props, state) {
		// only update on props change (let state changes go through)
		if (props === state.prevProps) {
			return null
		}
		// put own / want in state to allow the ui to be optimistically updated
		const { own, want, countOwned, countWanted } = props
		return { own, want, countOwned, countWanted, prevProps: props }
	}

	constructor(props) {
		super(props)

		this.state = {}

		this.doOwnSet = this.doOwnSet.bind(this)
		this.doWantSet = this.doWantSet.bind(this)
	}

	doOwnSet() {
		this.setState((state) => {
			const own = !state.own
			let countOwned = state.countOwned + (own ? 1 : -1)
			countOwned = countOwned < 0 ? 0 : countOwned
			this.props.ownSet(own)
			return { own, countOwned }
		})
	}

	doWantSet() {
		this.setState((state) => {
			const want = !state.want
			let countWanted = state.countWanted + (want ? 1 : -1)
			countWanted = countWanted < 0 ? 0 : countWanted
			this.props.wantSet(want)
			return { want, countWanted }
		})
	}

	testFitScoreGeneration(name) {
		let seed = Array.from(name).reduce((acc, c) => acc + c.charCodeAt(), 0)
		function random() {
			const x = Math.sin(seed) * 10000
			seed += 1
			return x - Math.floor(x)
		}
		return this.props.fitscore + (seed % 2 === 0 ? -1 : 1) * Math.floor((random()) * 10 + 1)
	}

	render() {
		const showCountOwned = this.props.showCounts && !!(this.state.countOwned && this.state.countOwned !== 0)
		const showCountWanted = this.props.showCounts && !!(this.state.countWanted && this.state.countWanted !== 0)
		const baseClasses = [...this.props.smallerButtons ? [styles.smallerButtons] : [], ...!this.props.showIcons ? [styles.noIcon] : []]

		return (
			<span className={classNames(styles.ownWant, this.props.className)}>
				{this.props.showFits && (
					<span className={styles.fitsMeContainer}>
						<div className={styles.fitsMe}>{this.context.translate('{fitscore}% fits me', { fitscore: this.testFitScoreGeneration(this.props.title) })}</div>
					</span>
				)}
				{this.props.buyUrl && (
					<BuyButton
						showIcons={this.props.showIcons}
						smallerButtons={this.props.smallerButtons}
						classes={{ root: classNames(styles.compactButton, ...baseClasses) }}
						buyUrl={this.props.buyUrl}
						buyItemKey={this.props.buyItemKey}
						buyBrand={this.props.buyBrand}
					/>
				)}
				{this.props.showOwn && (
					<Button variant="contained" classes={{ root: classNames(styles.compactButton, ...baseClasses, { [styles.selected]: this.state.own }) }} onClick={this.doOwnSet}>
						{this.props.showIcons && (this.state.own ? <Icon name="whiteTick" /> : <Icon name="blackTick" />)}
						{showCountOwned && this.context.translate('{countOwned} own', { countOwned: shortNumber(this.state.countOwned) })}
						{!showCountOwned && this.context.translate('own')}
					</Button>
				)}
				{this.props.showWant && (
					<Button variant="contained" classes={{ root: classNames(styles.lastCompactButton, ...baseClasses, { [styles.selected]: this.state.want }) }} onClick={this.doWantSet}>
						{this.props.showIcons && (this.state.want ? <Icon name="whiteBookmark" /> : <Icon name="blackBookmark" />)}
						{showCountWanted && this.context.translate('{countWanted} want', { countWanted: shortNumber(this.state.countWanted) })}
						{!showCountWanted && this.context.translate('want')}
					</Button>
				)}
			</span>
		)
	}
}

OwnWant.propTypes = {
	className: PropTypes.string,
	title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),	//	NOTE: Only used for the fake fit score
	fitscore: PropTypes.number,
	smallerButtons: PropTypes.bool,
	buyUrl: PropTypes.string,
	buyItemKey: PropTypes.string,
	buyBrand: PropTypes.string,
	showFits: PropTypes.bool,
	showIcons: PropTypes.bool,
	showCounts: PropTypes.bool,
	showOwn: PropTypes.bool,
	showWant: PropTypes.bool,
	own: PropTypes.bool,
	want: PropTypes.bool,
	countOwned: PropTypes.number,
	countWanted: PropTypes.number,
	ownSet: PropTypes.func.isRequired,
	wantSet: PropTypes.func.isRequired
}

OwnWant.defaultProps = {
	fitscore: 87,
	//	TODO: Remove title, as it is only used to calculate the fake fit score
	title: 'Kitfit',
	className: undefined,
	smallerButtons: false,
	buyUrl: undefined,
	buyItemKey: undefined,
	buyBrand: undefined,
	showFits: false,
	showIcons: true,
	showCounts: true,
	own: false,
	want: false,
	showOwn: true,
	showWant: true,
	countOwned: undefined,
	countWanted: undefined
}

OwnWant.contextTypes = {
	translate: PropTypes.func
}

export default OwnWant



// WEBPACK FOOTER //
// ./src/components/OwnWant.jsx